export default "__VITE_ASSET__DeB7r8Fe__"